// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__QZZVy","title":"AfterFrontImage_title__30FCj"};